var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconionicIosAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.625,
    height: 17.625,
    viewBox: "0 0 17.625 17.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-alert",
    "data-name": "Icon ionic-ios-alert",
    d: "M12.187,3.375A8.813,8.813,0,1,0,21,12.187,8.811,8.811,0,0,0,12.187,3.375Zm.729,4.644L12.785,12.9a.606.606,0,0,1-.6.627h0a.606.606,0,0,1-.6-.627l-.131-4.877a.73.73,0,0,1,.729-.746h0A.73.73,0,0,1,12.916,8.019Zm-.729,8.321A.78.78,0,1,1,13,15.56.787.787,0,0,1,12.187,16.34Z",
    transform: "translate(-3.375 -3.375)",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicIosAlert);
export default __webpack_public_path__ + "static/media/Icon ionic-ios-alert.a7e6e4fe072bdfb7cabe156997b1016a.svg";
export { ForwardRef as ReactComponent };